import React, { useEffect, useState } from 'react'

const STORAGE_KEY = 'sarahadom-site-rating'

export default function RateSite() {
  const [rating, setRating] = useState(0)
  const [hovered, setHovered] = useState(0)

  useEffect(() => {
    const saved = Number(localStorage.getItem(STORAGE_KEY) || 0)
    if (saved >= 1 && saved <= 5) setRating(saved)
  }, [])

  const handleRate = (value) => {
    setRating(value)
    localStorage.setItem(STORAGE_KEY, String(value))
  }

  return (
    <div className="footer-rate-wrap" aria-label="Rate this site">
      <p className="footer-rate-title">Rate this site</p>
      <div className="footer-rate-stars" role="radiogroup" aria-label="Site rating">
        {[1, 2, 3, 4, 5].map((star) => {
          const active = (hovered || rating) >= star
          return (
            <button
              key={star}
              type="button"
              className={`footer-rate-star ${active ? 'is-active' : ''}`}
              onClick={() => handleRate(star)}
              onMouseEnter={() => setHovered(star)}
              onMouseLeave={() => setHovered(0)}
              aria-label={`${star} star${star > 1 ? 's' : ''}`}
              aria-checked={rating === star}
              role="radio"
            >
              ★
            </button>
          )
        })}
      </div>
      {rating > 0 && <p className="footer-rate-thanks">Thanks for rating us {rating}/5!</p>}
    </div>
  )
}
